import { Tooltip } from '@mui/material';
import l from '../../../lang';
import { ReactComponent as TransactionCompletedIcon } from '../../../assets/icons/client-transaction-completed.svg';
import './styles.scss';

export interface TransactionCompletedStatusIconProps {
  iconClassName?: string;
  wrapClassName?: string;
  tooltipTitle?: string;
}

const TransactionCompletedStatusIcon = ({
  iconClassName = '',
  wrapClassName = '',
  tooltipTitle,
}: TransactionCompletedStatusIconProps) => {
  const label = tooltipTitle ?? l('clients.transactionStatus.completed');

  return (
    <Tooltip title={label} arrow describeChild>
      <span
        className={`transaction-completed-status-icon__wrap ${wrapClassName}`.trim()}
        tabIndex={0}
        aria-label={label}
      >
        <TransactionCompletedIcon
          className={`transaction-completed-status-icon ${iconClassName}`.trim()}
          aria-hidden
        />
      </span>
    </Tooltip>
  );
};

export default TransactionCompletedStatusIcon;
